import { Button, Flex, Space, Tag, Typography } from 'antd'
import { ArticleType } from 'src/pages/budget/types'
import {
  closeModalArticle,
  toggleModalArticleForEdit,
} from 'src/pages/budget/budgetCategories/model'
import { useUsers } from 'src/pages/budget/hook'
import { useState } from 'react'
import { formatPeople } from 'src/pages/budget/utils'
import { LinkifiedText, UiText } from 'src/pages/budget/components'

type ViewArticleProps = {
  article: ArticleType
}

export const ViewArticle = ({ article }: ViewArticleProps) => {
  const [expanded, setExpanded] = useState(false)
  const [isEllipsis, setIsEllipsis] = useState(false)
  const { number, name, description, users } = article
  const { allUsersMap } = useUsers()

  const { Paragraph } = Typography

  const handleToggle = () => toggleModalArticleForEdit()
  const handleCancel = () => closeModalArticle()

  return (
    <Flex vertical gap="large">
      <Space direction="vertical" size="small">
        <UiText size={18} type="secondary">
          Статья
        </UiText>
        <UiText size={18}>
          {number}.{name}
        </UiText>
      </Space>
      <Space direction="vertical">
        <UiText size={18} type="secondary">
          Описание
        </UiText>
        <UiText size={18}>
          <LinkifiedText text={description} />
        </UiText>
      </Space>
      <Space direction="vertical">
        <UiText size={18} type="secondary">
          Доступы {formatPeople(users.length)}
        </UiText>
        <Paragraph
          style={{ margin: 0, flex: 1 }}
          ellipsis={{
            rows: 4,
            expandable: 'collapsible',
            expanded,
            symbol: () => null,
            onEllipsis: setIsEllipsis,
          }}
        >
          {users.map((userId) => {
            const userName = allUsersMap.get(userId)
            return (
              <Tag key={userId} style={{ marginBottom: 4, fontSize: 16 }}>
                {userName}
              </Tag>
            )
          })}
        </Paragraph>
        {isEllipsis && (
          <div
            style={{
              cursor: 'pointer',
              color: 'var(--color-primary)',
            }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? 'Показать меньше' : 'Показать больше'}
          </div>
        )}
      </Space>
      <Flex gap={8}>
        <Button style={{ flex: 1 }} onClick={handleCancel} size="large">
          Отменить
        </Button>
        <Button
          style={{ flex: 1 }}
          type="primary"
          size="large"
          htmlType="submit"
          onClick={handleToggle}
        >
          Редактировать
        </Button>
      </Flex>
    </Flex>
  )
}
